/** Reject Unix epoch (0) and pre-2000 garbage when computing visible "trial window" min/max. */
const MIN_PLAUSIBLE_CYCLE_MS = Date.UTC(2000, 0, 1);

/**
 * First plausible instant from row, in field order (same priority as existing `a || b` chains).
 * @param {object} row
 * @param {string[]} fieldOrder
 * @returns {number} epoch ms, or NaN if none
 */
export function plausibleHistoryInstantMs(row, fieldOrder) {
  if (!row || typeof row !== "object") return NaN;
  for (const key of fieldOrder) {
    const raw = row[key];
    if (raw == null || raw === "") continue;
    if (typeof raw === "number" && raw === 0) continue;
    const t = new Date(raw).getTime();
    if (!Number.isNaN(t) && t >= MIN_PLAUSIBLE_CYCLE_MS) return t;
  }
  return NaN;
}
